module.exports = __webpack_public_path__ + "img/mytask_2.dd532d07.jpg";